const setApps = (state, aps) => {
  state.apps = aps
}

const setClusters = (state, cls) => {
  state.clusters = cls
}
const setDevices = (state, dvs) => {
  state.devices = dvs
}
const setPlaylists = (state, pls) => {
  state.playlists = pls
}
const setPlaylistsArchive = (state, pls) => {
  state.playlistsArchive = pls
}

const setMenus = (state, men) => {
  state.menus = men
}
const setMenusArchive = (state, men) => {
  state.menusArchive = men
}

const setSpecialOffers = (state, offs) => {
  state.specialOffers = offs
}
const setSpecialOffersArchive = (state, offs) => {
  state.specialOffersArchive = offs
}

const setAirQuality = (state, types) => {
  state.pollutionTypes = types
}

const setWeatherCities = (state, cities) => {
  state.weatherCities = cities
}

const setWeatherApiKey = (state, apiKey) => {
  state.weatherApiKey = apiKey
}

const setAddOns = (state, addons) => {
  state.addOns = addons
}

const setCampaigns = (state, camps) => {
  state.campaigns = camps
}

const setPowerDevices = (state, pwd) => {
  state.powerDevices = pwd
}

const setWorkspaceId = (state, wId) => {
  state.workspaceId = wId
}

const setRole = (state, rl) => {
  state.role = rl
}

const setCustomerSatisfaction = (state, cs) => {
  state.customerSatisfaction = cs
}

const setFrontDesk = (state, fd) => {
  state.frontDesk = fd
}

const setDocuments = (state, dcs) => {
  state.documents = dcs
}

const setQuestionnaires = (state, qrs) => {
  state.questionnaires = qrs
}

const setQuestionnaireAnswers = (state, qra) => {
  state.questionnaireAnswers = qra
}

const setAppMenu = (state, am) => {
  state.appMenu = am
}

const setAppMenuPdfs = (state, ampdfs) => {
  state.appMenuPdfs = ampdfs
}

const setTickets = (state, tkts) => {
  state.tickets = tkts
}

export default {
  setApps,
  setClusters,
  setDevices,
  setPlaylists,
  setPlaylistsArchive,
  setMenus,
  setMenusArchive,
  setSpecialOffers,
  setSpecialOffersArchive,
  setAirQuality,
  setWeatherCities,
  setWeatherApiKey,
  setAddOns,
  setCampaigns,
  setPowerDevices,
  setWorkspaceId,
  setRole,
  setCustomerSatisfaction,
  setFrontDesk,
  setDocuments,
  setQuestionnaires,
  setQuestionnaireAnswers,
  setAppMenu,
  setAppMenuPdfs,
  setTickets
}



// WEBPACK FOOTER //
// ./src/store/mutations.js